export default "__VITE_ASSET__29faee0a__"